import React from 'react';
import { Card, CardContent, Typography, Box, Chip, useTheme } from '@mui/material';
import { EventLogType } from 'app/context/EventLogContext';
import { AccessTime, LocationOn } from '@mui/icons-material';
import { formatToLocalTime } from 'utils/dateUtils';

interface Props {
  log: EventLogType;
}

export const EventLogCard: React.FC<Props> = ({ log }) => {
  const theme = useTheme();

  return (
    <Card
      variant="outlined"
      sx={{ 
        width: '100%', 
        borderRadius: 2, 
        backgroundColor: '#ffffff',
        mb: 1.5,
        boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
        transition: 'all 0.2s ease-in-out',
        '&:hover': {
          boxShadow: '0 2px 6px rgba(0,0,0,0.15)',
          transform: 'translateY(-1px)'
        }
      }}
    >
      <CardContent sx={{ py: 1.5, px: 2 }}>
        <Box display="flex" justifyContent="space-between" alignItems="center" mb={1.5}>
          <Box display="flex" alignItems="center" gap={3}>
            <Box display="flex" alignItems="center" gap={1}>
              <AccessTime sx={{ fontSize: 16, color: theme.palette.text.primary }} />
              <Typography variant="subtitle2" color="textSecondary">
                {log.created_date ? formatToLocalTime(log.created_date) : 'No Timestamp'}
              </Typography>
            </Box>
            <Box display="flex" alignItems="center" gap={1}>
              <LocationOn sx={{ fontSize: 16, color: theme.palette.text.primary }} />
              <Typography variant="subtitle2" color="textSecondary">
                {log.originating_ip || 'N/A'}
              </Typography>
            </Box>
          </Box>
          <Chip
            label={log.event_type || 'UNKNOWN_EVENT'}
            color="primary"
            size="small"
            sx={{ 
              fontWeight: 600,
              minWidth: '100px',
              height: '24px',
              '& .MuiChip-label': {
                px: 1.5
              }
            }}
          />
        </Box>
        <Typography 
          variant="body2" 
          sx={{ 
            color: 'text.primary',
            wordBreak: 'break-word',
            lineHeight: 1.5,
            pl: 0.5
          }}
        >
          {log.message || 'No message provided.'}
        </Typography>
      </CardContent>
    </Card>
  );
};

export default EventLogCard;
